/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChatConversation
 */
export interface ChatConversation {
    /**
     * 
     * @type {number}
     * @memberof ChatConversation
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof ChatConversation
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof ChatConversation
     */
    claimId?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatConversation
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof ChatConversation
     */
    title?: string;
    /**
     * 
     * @type {Date}
     * @memberof ChatConversation
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ChatConversation
     */
    readonly updatedAt: Date;
}

/**
 * Check if a given object implements the ChatConversation interface.
 */
export function instanceOfChatConversation(value: object): value is ChatConversation {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ChatConversationFromJSON(json: any): ChatConversation {
    return ChatConversationFromJSONTyped(json, false);
}

export function ChatConversationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatConversation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'claimId': json['claimId'] == null ? undefined : json['claimId'],
        'userId': json['userId'],
        'title': json['title'] == null ? undefined : json['title'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function ChatConversationToJSON(json: any): ChatConversation {
    return ChatConversationToJSONTyped(json, false);
}

export function ChatConversationToJSONTyped(value?: Omit<ChatConversation, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'claimId': value['claimId'],
        'userId': value['userId'],
        'title': value['title'],
    };
}

